// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#040f42","menuText":"#767f99","menuActiveText":"#409eff"};